import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from './Button';

interface ActionCardProps {
  icon: IconDefinition;
  title: string;
  description: string;
  primaryCTA: {
    text: string;
    onClick: () => void;
  };
}

/**
 * Reusable action card component
 * Used in ActionIndicator expanded panel to show pending actions
 * Displays icon, title, description, and CTA button
 */
function ActionCard({ icon, title, description, primaryCTA }: ActionCardProps) {
  return (
    <div
      className="p-4 bg-gray-50 border border-gray-200 rounded-lg space-y-3"
      role="article"
      aria-label={title}
    >
      {/* Icon + Title */}
      <div className="flex items-center space-x-2">
        <FontAwesomeIcon icon={icon} className="text-cYellow" size="lg" />
        <h3 className="text-base font-semibold text-primaryDark">{title}</h3>
      </div>

      {/* Description */}
      <p className="text-sm text-gray-600 leading-relaxed">{description}</p>

      {/* CTA Button */}
      <Button
        buttonText={primaryCTA.text}
        buttonType="primary"
        actionHandler={primaryCTA.onClick}
      />
    </div>
  );
}

export default ActionCard;
